import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import Maybe from 'components/__new/common/Maybe';
import { ButtonLoader, Input } from 'components/__new/common/form';
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
import * as walletAction from "store/entities/wallet/action";
import useLoginInfo from 'hooks/useLoginInfo';
import * as transfersAction from "store/entities/transfers/action"
import processParams from 'utils/processParams';
import useUrlQueryParams from 'hooks/useUrlQueryParams';


const EarnipaySingleBeneficiary = ({ loading, toggleBeneficiaryType, initiateBeneficiaryCreation, setIsOpen, transferBeneficiary }) => {
    const { userInfo } = useLoginInfo();
    const {urlQueryParams} = useUrlQueryParams();
    const dispatch = useDispatch();
    const {validateEarnipayAccountLoading, validateEarnipayAccountData} = useSelector((state) => state.entities.wallet);

    const [form, setForm] = useState({
        accountNumber: "",
        alias: "",
    });
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    const [validatedBeneficiary, setValidatedBeneficiary] = useState(null);

    const onSubmit = (e) => {
        e.preventDefault();

        const payload = {
            type: "intra",
            accountNumber: form?.accountNumber?.toString(),
            alias: form?.alias,
            walletId: validateEarnipayAccountData?.data?.walletId,
            accountName: validateEarnipayAccountData?.data?.accountName,
            accountNumber: validateEarnipayAccountData?.data?.accountNumber,
            bankName: validateEarnipayAccountData?.data?.bankName,
            bankCode: validateEarnipayAccountData?.data?.bankCode,
            employerId: userInfo?.employer?._id
        }
        initiateBeneficiaryCreation(payload);
    }
    
    const getTransferBeneficiaries = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "keyword");
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");

        setListParams(params);
        dispatch(transfersAction.getTransferBeneficiaries());
    }

    useEffect(() => {
        getTransferBeneficiaries();
        // eslint-disable-next-line
    }, [location]);

    useEffect(() => {
        if(form?.accountNumber?.length === 10) {
            dispatch(walletAction.validateEarnipayAccount(form?.accountNumber));
        }
        // eslint-disable-next-line
    }, [form.accountNumber])
    
    
    useEffect(() => {
        if(validateEarnipayAccountData?.success === true) {
            setValidatedBeneficiary(validateEarnipayAccountData?.data)
            setForm({
                ...form,
                ...validateEarnipayAccountData?.data
            })
        }
        // eslint-disable-next-line
    }, [validateEarnipayAccountData])
    
    
    useEffect(() => {
        setValidatedBeneficiary(null);
        setForm({
            accountNumber: "",
            alias: "",
        })
    //  eslint-disable-next-line
    }, [])
    
    useEffect(() => {
        if (transferBeneficiary?.status === "success") {
            toast.success("Beneficiary created");
            setIsOpen(false);
            getTransferBeneficiaries();
            dispatch(transfersAction.resetCreateTransferBeneficiary())
        }
    }, [transferBeneficiary]);
    
    const disableSubmit = form?.accountNumber?.length !== 10 || validateEarnipayAccountData === null || !form.alias
    
    return (
        <div className='w-full mt-3'>
            <form onSubmit={onSubmit}>
                
                <Input
                    type="text"
                    label="Beneficiary Name"
                    value={form?.alias}
                    className="form-input"
                    placeholder="Enter name"
                    onChange={(e) => setForm({...form, alias: e.target.value})}
                />
                
                <div className="form-group relative">
                    <label>Account Number</label>
                    
                    <input
                        type="number"
                        id="prl-input"
                        className="form-input"
                        value={form.accountNumber}
                        placeholder="Account Number"
                        onChange={(e) => { setForm({...form, accountNumber: e.target.value}); setValidatedBeneficiary(null)}}
                    />
                    
                    <Maybe condition={validatedBeneficiary !== null}>
                        <div className="w-full flex items-center justify-start">
                            <div className="flex items-center text-sm">
                                <IconCheckCircle width={15} />
                                <div className='ml-1.5 text-[#153344] capitalize'>
                                    {validatedBeneficiary?.firstName} {validatedBeneficiary?.lastName}
                                </div>
                            </div>
                        </div>
                    </Maybe>
                </div>
                
                <div className="border-t w-full flex items-center justify-end mt-7 pt-5">
                    <button type="button" onClick={toggleBeneficiaryType} className="btn btn-transparent-primary mr-3">
                        Cancel
                    </button>
                    
                    <ButtonLoader loading={loading} disabled={disableSubmit || validateEarnipayAccountLoading} type="submit" className="btn btn-ep-primary">
                        {validateEarnipayAccountLoading ? "Validating..." : "Add Beneficiary"}
                    </ButtonLoader>
                </div>
            </form>
        </div>
    )
}


export default EarnipaySingleBeneficiary